import { useEffect, useRef } from 'react';
import { useAuth } from '@/routes/AuthContext';
import { useMfa } from '../MfaContext';
import { useMfaSetupGuard } from '../hooks/useMfaSetupGuard';

/**
 * Syncs org MFA + setup status from the server on authenticated session load.
 */
export const MfaSetupGuardSync = () => {
  const { isAuthenticated, isLoading: authLoading, user } = useAuth();
  const { setOrganizationMfaEnabled, setAuthEmail, setMfaVerificationMode } =
    useMfa();
  const { data } = useMfaSetupGuard(user?.email);
  const wasAuthenticatedRef = useRef(false);

  useEffect(() => {
    if (data) {
      setOrganizationMfaEnabled(data.organizationMfaEnabled);
    }
  }, [data, setOrganizationMfaEnabled]);

  useEffect(() => {
    if (isAuthenticated) {
      wasAuthenticatedRef.current = true;
      return;
    }

    if (wasAuthenticatedRef.current && !authLoading) {
      setOrganizationMfaEnabled(false);
      setAuthEmail(null);
      setMfaVerificationMode(null);
      wasAuthenticatedRef.current = false;
    }
  }, [
    authLoading,
    isAuthenticated,
    setAuthEmail,
    setMfaVerificationMode,
    setOrganizationMfaEnabled,
  ]);

  return null;
};
